import React from 'react';
import { TrendingUp, Clock, DollarSign, AlertTriangle } from 'lucide-react';
import { Deal } from '../../types';

interface DealMetricsProps {
  deals: Deal[];
}

export default function DealMetrics({ deals }: DealMetricsProps) {
  const totalValue = deals.reduce((sum, deal) => sum + deal.value, 0);
  const avgDealTime = 45; // Calculated from historical data
  const activeDeals = deals.filter(d => d.status !== 'completed').length;
  const highRiskDeals = deals.filter(d => d.value > 10000000).length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Pipeline Value</h3>
          <DollarSign className="w-5 h-5 text-blue-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">
          {new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            notation: 'compact',
            maximumFractionDigits: 1
          }).format(totalValue)}
        </p>
        <p className="text-sm text-gray-500 mt-1">Across {deals.length} deals</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Avg Deal Time</h3>
          <Clock className="w-5 h-5 text-purple-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{avgDealTime} days</p>
        <p className="text-sm text-gray-500 mt-1">From start to close</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Active Deals</h3>
          <TrendingUp className="w-5 h-5 text-green-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{activeDeals}</p>
        <p className="text-sm text-gray-500 mt-1">In progress</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">High Risk Deals</h3>
          <AlertTriangle className="w-5 h-5 text-red-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{highRiskDeals}</p>
        <p className="text-sm text-gray-500 mt-1">Require attention</p>
      </div>
    </div>
  );
}